import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=7074f9fb"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7074f9fb')) {
      api.createRecord('7074f9fb', component.options)
    } else {
      api.reload('7074f9fb', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=7074f9fb", function () {
      api.rerender('7074f9fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Help.vue"
export default component.exports